export default "__VITE_ASSET__qg31sgBB__"